import React from 'react';
import PropTypes from 'prop-types';
import {Wrapper, Top, NameWrapper, Border} from './MenuName.style';

const MenuName = props => {
  const {menuName} = props;
  return (
    <Wrapper>
      <Top />
      <NameWrapper>
        <Border />
        {menuName}
        <Border />
      </NameWrapper>
    </Wrapper>
    );
};

MenuName.propTypes = {
  menuName: PropTypes.string.isRequired
};

export default MenuName;



// WEBPACK FOOTER //
// ./containers/MenuPage/MenuName.js